import { createAsyncThunk } from "@reduxjs/toolkit";
import publisherAPIs from "services/api/publisher";

export const getSocialMediaProviderProfiles = createAsyncThunk(
  "socialProfile/getSocialMediaProviderProfiles",
  async (payload) => {
    try {
      const response = await publisherAPIs.getSocialMediaProviderProfiles(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data || error;
    }
  },
);
